<template>
  <div>
    <van-tabbar route safe-area-inset-bottom active-color="#f44">
      <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item v-if="showMenu('分类')" replace to="/category" icon="apps-o">分类</van-tabbar-item>
      <!-- <van-tabbar-item url="https://h5.daeyes.com.cn" icon="coupon-o">电影</van-tabbar-item> -->
      <van-tabbar-item v-if="showMenu('电影')" url="https://film.daeyes.com" icon="coupon-o">
        <span>电影</span>
        <template #icon>
          <img src="../assets/image/movie.png" alt="">
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-if="showMenu('演出')" url="https://m.show.daeyes.com/" icon="coupon-o">
        <span>演出</span>
        <template #icon>
          <img src="../assets/image/show.png" alt="">
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/cart" icon="cart-o"  v-if="cartCount > 0" :badge="cartCount">购物车</van-tabbar-item>
      <van-tabbar-item to="/cart" icon="cart-o"  v-else>购物车</van-tabbar-item>
      <van-tabbar-item replace to="/mine" icon="contact-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "Tabbar",
  data () {
    return {
    };
  },
  computed: {
    menus () {
      return this.$store.getters.setting.BarMenuList;
    },
    cartCount(){
      return this.$store.state.cartCount;
    }
  },
  activated(){
    //this.loadCartCount();
  },
  methods: {
    // 显示菜单项
    showMenu (name) {
      if (this.menus) {
        let menu = this.menus.filter((item) => item === name);
        //console.log(menu);
        if (menu.length > 0) return true;
      }
      return false;
    },
  },
  mounted () {
    // console.log(this.$store.state.setting);
  },
};
</script>

<style lang="less" scoped></style>